export default "__VITE_ASSET__13bc7bf2__"